import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

function clientesPDF(dados_pedido, tipoImpressao) {
  try {
    const cobra_frete = dados_pedido.cobra_frete
    const clientes = dados_pedido.itens
    const frete = dados_pedido.valor_frete
    const obs = dados_pedido.detalhes_pedido
    const NomeCliente = dados_pedido.cliente
    const numeroorc = dados_pedido.numeroorc
    const idpedidoloja = dados_pedido.orderid
    const { data, cpf } = dados_pedido
    const DadosCliente = dados_pedido.dadosDoCliente
    const EnderecoEnt = dados_pedido.EnderecoEnt
    const tipoVenda = dados_pedido.tipo_pedido
    //const dataFormatada = format(new Date(data), 'dd/MM/yyyy')
    const empresa = dados_pedido.empresa[0]
    let valorTotalItem = 0

    const dataOriginal = data.split('-')
    const dataFormatada = `${dataOriginal[2]}/${dataOriginal[1]}/${dataOriginal[0]}`

    function formatarCPFouCNPJ(cpfOuCnpj) {
      // Verifica se é CPF (11 dígitos) ou CNPJ (14 dígitos)
      if (cpfOuCnpj && cpfOuCnpj.length === 11) {
        return cpfOuCnpj.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          '$1.$2.$3-$4',
        ) // Formata CPF: XXX.XXX.XXX-XX
      } else if (cpfOuCnpj && cpfOuCnpj.length === 14) {
        return cpfOuCnpj.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
          '$1.$2.$3/$4-$5',
        ) // Formata CNPJ: XX.XXX.XXX/YYYY-ZZ
      } else {
        return 'Não informado'
      }
    }

    const cpfOuCnpjFormatado = formatarCPFouCNPJ(cpf)

    const clienteNomeComCPF = cpfOuCnpjFormatado
      ? `${NomeCliente}\nCPF/CNPJ: ${cpfOuCnpjFormatado}`
      : NomeCliente

    function formatCurrency(value) {
      if (value === null || isNaN(value)) {
        return '0,00'
      }
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    }

    function formatNumber(value) {
      if (value === null) {
        return '0,00'
      }
      return value.toLocaleString('pt-BR')
    }

    pdfMake.addVirtualFileSystem(pdfFonts)

    const primaryColor = '#007BFF'
    const secondaryColor = '#333333'

    const styles = {
      tableExample: {
        margin: [0, 5, 0, 15],
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: primaryColor,
      },
      tableHeaderBackground: {
        fillColor: primaryColor,
        color: '#fff',
      },
      // tableFooter: {
      //     bold: true,
      //     fontSize: 12,
      //     color: primaryColor,
      // },
    }

    const reportTitle = [
      {
        text: `Pedido de ${tipoVenda && tipoVenda.toLowerCase() === 'reposicao' ? 'reposição' : tipoVenda ? tipoVenda.toLowerCase() : 'venda'}`,
        fontSize: 24,
        bold: true,
        margin: [0, 0, 0, 20],
        color: primaryColor,
      },
    ]

    const orcamento = [
      {
        columns: [
          {
            text: `Pedido: ${numeroorc}`,
            fontSize: 12,
            margin: [0, 0, 10, 5],
          },
          {
            text: `Order ID: ${idpedidoloja}`,
            fontSize: 12,
            margin: [10, 0, 10, 5],
          },
          {
            text: `Data: ${dataFormatada}`,
            fontSize: 12,
            margin: [10, 0, 0, 20],
          },
        ],
      },

      {
        text: 'Dados do cliente:',
        fontSize: 12,
        bold: true,
        color: primaryColor,
        margin: [0, 0, 0, 10],
      },
      {
        text: `Cliente: ${clienteNomeComCPF}`,
        fontSize: 10,
        margin: [0, 0, 0, 5],
      },

      {
        text: `Endereço do Cliente`,
        fontSize: 11,
        bold: true,
        margin: [0, 0, 0, 8],
      },
      {
        text: [
          { text: `Contato: ${DadosCliente.pes_celular}\n`, fontSize: 9 },
          {
            text: `${DadosCliente.pes_logradouro}, ${DadosCliente.pes_numero}\n`,
            fontSize: 9,
          },
          { text: `${DadosCliente.pes_bairro}, `, fontSize: 9 },
          {
            text: `${DadosCliente.pes_cidade} - ${DadosCliente.pes_uf}\n`,
            fontSize: 9,
          },
          { text: `CEP: ${DadosCliente.pes_cep}\n`, fontSize: 9 },
        ],

        fontSize: 9,
        margin: [0, 0, 10, 0],
      },
    ]

    // Verifica se existe um endereço antes de adicioná-lo
    const endEnt = [
      {
        canvas: [
          {
            type: 'rect',
            x: 0,
            y: 0,
            w: 515,
            h: 60,
            color: '#F0F0F0',
            lineColor: '#D1D1D1',
            lineWidth: 1,
            roundedCorner: 5,
          },
        ],
        stack: [
          {
            text: 'Endereço de Entrega',
            fontSize: 11,
            bold: true,
            margin: [0, 0, 0, 5], // Adicionei uma margem abaixo do título
          },
          {
            text: EnderecoEnt,
            fontSize: 10,
            margin: [0, 0, 10, 0],
          },
        ],
      },
    ]

    const larguraColunas = [
      '8%',
      '25%',
      '8%',
      '10%',
      '10%',
      '12%',
      '12%',
      '15%',
    ]

    const dados = clientes.map((cliente) => {
      valorTotalItem = cliente.valorunitario * cliente.quantidade
      console.log(valorTotalItem)

      // Verifica se tipoImpressao é "Completo"
      if (tipoImpressao === 'Resumo') {
        // Obtém apenas a primeira palavra da descrição
        const primeiraPalavra = cliente.descricao
          ? cliente.descricao.split(' ')[0].toUpperCase()
          : 'Não informado'

        // Retorna os dados com a primeira palavra da descrição
        return [
          {
            text: cliente.codigo
              ? cliente.codigo.toUpperCase()
              : 'Não informado',
            fontSize: 7,
            margin: [0, 2, 0, 2],
          },
          {
            text: primeiraPalavra,
            fontSize: 7,
            margin: [0, 2, 0, 2],
            width: 150,
          },

          {
            text: formatNumber(cliente.quantidade),
            fontSize: 7,
            margin: [0, 2, 0, 2],
            alignment: 'right',
          },
          {
            text: formatCurrency(cliente.valorunitario),
            fontSize: 7,
            margin: [0, 2, 0, 2],
          },
          {
            text: cliente.desconto ? formatCurrency(cliente.desconto) : '0,00',
            fontSize: 7,
            margin: [0, 2, 0, 2],
          },

          {
            text: formatCurrency(valorTotalItem),
            fontSize: 7,
            margin: [0, 2, 0, 2],
          },
          {
            text: formatCurrency(cliente.valor_total_item),
            fontSize: 7,
            margin: [0, 2, 0, 2],
          },
          { text: cliente.obs || 'S/Obs', fontSize: 7, margin: [0, 2, 0, 2] },
        ]
      } else {
        // Retorna os dados sem alteração se tipoImpressao não for "Completo"
        return [
          {
            text: cliente.codigo
              ? cliente.codigo.toUpperCase()
              : 'Não informado',
            fontSize: 6,
            margin: [0, 2, 0, 2],
          },
          {
            text: cliente.descricao
              ? cliente.descricao.toUpperCase()
              : 'Não informado',
            fontSize: 6,
            margin: [0, 2, 0, 2],
            width: 150,
          },
          {
            text: formatNumber(cliente.quantidade),
            fontSize: 6,
            margin: [0, 2, 0, 2],
            alignment: 'right',
          },
          {
            text: formatCurrency(cliente.valorunitario),
            fontSize: 6,
            margin: [0, 2, 0, 2],
          },

          {
            text: cliente.desconto ? formatCurrency(cliente.desconto) : '0,00',
            fontSize: 6,
            margin: [0, 2, 0, 2],
          },

          {
            text: formatCurrency(valorTotalItem),
            fontSize: 6,
            margin: [0, 2, 0, 2],
          },
          {
            text: formatCurrency(cliente.valor_total_item),
            fontSize: 6,
            margin: [0, 2, 0, 2],
          },
          { text: cliente.obs || 'S/Obs', fontSize: 7, margin: [0, 2, 0, 2] },
        ]
      }
    })

    const details = [
      {
        table: {
          headerRows: 1,
          widths: larguraColunas,
          body: [
            [
              {
                text: 'Sku',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Descrição',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },

              {
                text: 'Quantidade',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Valor Uni. ',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Desconto',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Valor Total Item',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Valor Total',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Obs',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
            ],
            ...dados,
          ],
        },
      },
    ]

    // Cálculo do total dos itens
    const totalItens = clientes.reduce(
      (acc, cliente) => acc + cliente.valorunitario * cliente.quantidade,
      0,
    )

    // Cálculo do total de descontos
    const totalDescontos = clientes.reduce(
      (acc, cliente) => acc + (cliente.desconto || 0),
      0,
    )

    // Cálculo do valor total com descontos
    let valorTotalComDesconto = totalItens - totalDescontos

    // Adiciona o frete ao valor total, se aplicável
    if (cobra_frete === 'S') {
      valorTotalComDesconto += parseFloat(frete)
    }

    // Definindo o valor do frete a ser exibido baseado na condição cobraFrete
    const valorFreteParaExibir = cobra_frete === 'S' ? frete : 0

    // Parte do seu código onde o frete é exibido
    const freteExibicao = {
      text: formatCurrency(valorFreteParaExibir),
      style: 'tableFooter',
      color: primaryColor,
      alignment: 'right',
    }

    const Totais = [
      {
        table: {
          widths: ['*', 'auto'],
          body: [
            [
              {
                text: 'Valor Total dos Itens',
                style: 'tableFooter',
                color: primaryColor,
              },

              {
                text: formatCurrency(totalItens),
                style: 'tableFooter',
                color: primaryColor,
                alignment: 'right',
              },
            ],
            [
              {
                text: 'Frete',
                style: 'tableFooter',
                color: primaryColor,
              },

              freteExibicao,
            ],
            [
              {
                text: 'Valor Total do Desconto',
                style: 'tableFooter',
                color: primaryColor,
              },
              {
                text: formatCurrency(totalDescontos),
                style: 'tableFooter',
                color: primaryColor,
                alignment: 'right',
              },
            ],
            [
              {
                text: 'Total a Pagar',
                style: 'tableFooter',
                color: primaryColor,
              },
              {
                text: formatCurrency(valorTotalComDesconto),
                style: 'tableFooter',
                color: primaryColor,
                alignment: 'right',
              },
            ],
          ],
        },
        layout: 'noBorders',
      },
    ]

    function Rodape(currentPage, pageCount) {
      return [
        {
          text:
            'Impresso em ' +
            format(new Date(), 'dd/MM/yyyy HH:mm', { locale: ptBR }) +
            ' ZipHub Gestão',
          alignment: 'center',
          fontSize: 8,
          color: secondaryColor,
          margin: [0, 10, 0, 0],
        },
        {
          text: currentPage + ' / ' + pageCount,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 10, 20, 0],
        },
      ]
    }

    const cnpj = empresa?.EMP_CNPJ || 'Não informado'

    const companyDetails = [
      {
        stack: [
          {
            text: empresa?.EMP_RAZAO_SOCIAL,
            fontSize: 12,
            bold: true,
            color: secondaryColor,
          },
          {
            text: `${empresa?.EMP_ENDERECO}, ${empresa?.EMP_NUMERO} - ${empresa?.EMP_CIDADE}-${empresa.EMP_ESTADO} Cep: ${empresa.EMP_CEP}`,
            fontSize: 10,
            color: secondaryColor,
          },
          {
            text: `Telefone: ${empresa.EMP_TELEFONE}`,
            fontSize: 10,
            color: secondaryColor,
          },
          {
            text: `CNPJ: ${empresa.EMP_CNPJ}`,
            fontSize: 10,
            color: secondaryColor,
          },
        ],
        alignment: 'right',
        margin: [0, 10, 20, 0],
      },
    ]

    // const companyDetails = [
    //     {
    //         text: empresa?.EMP_RAZAO_SOCIAL,
    //         alignment: "right",
    //         fontSize: 12,
    //         bold: true,
    //         margin: [0, 10, 20, 0],
    //         color: "#6C757D"
    //     },
    //     {
    //         text: empresa?.EMP_ENDERECO + ', ' + empresa?.EMP_NUMERO + ' - ' + empresa?.EMP_CIDADE + '-' + empresa?.EMP_ESTADO +
    //             ' Cep: ' + empresa?.EMP_CEP,
    //         alignment: 'right',
    //         fontSize: 10,
    //         margin: [0, 0, 20, 0],
    //         color: secondaryColor,
    //     },
    //     {
    //         text: 'Telefone: ' + empresa?.EMP_TELEFONE,
    //         alignment: 'right',
    //         fontSize: 10,
    //         margin: [0, 0, 20, 0],
    //         color: secondaryColor,
    //     },
    //     {
    //         text: 'CNPJ: ' + cnpj,
    //         alignment: 'right',
    //         fontSize: 10,
    //         margin: [0, 0, 20, 0],
    //         color: secondaryColor,
    //     },
    // ];

    console.log(companyDetails)

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [15, 50, 15, 40],

      header: [...companyDetails],

      content: [
        ...reportTitle,
        ...orcamento, // Incluindo os dados do cliente no orçamento
        { text: ' ', margin: [0, 10] },
        ...details,
        { text: ' ', margin: [0, 10] },
        ...Totais,
        {
          text: 'Observações:',
          fontSize: 12,
          bold: true,
          color: primaryColor,
          margin: [0, 20, 0, 5],
        }, // Título das observações
        { text: obs || 'Sem observações', fontSize: 10, margin: [0, 0, 0, 10] }, // Conteúdo das observações

        ...endEnt,
      ],
      footer: Rodape,
      styles: styles,
    }

    // Crie o PDF e abra-o em uma nova guia
    pdfMake.createPdf(docDefinition).open()
  } catch (error) {
    console.error('Erro no pdfMake:', error)
  }
}

export default clientesPDF
